/**
 * 逆ジオコーディングを行い、日本語で住所情報を取得し粒度ごとに分割
 * @param {number} lat - 緯度
 * @param {number} lng - 経度
 * @returns {} - 住所粒度ごとに分割されたオブジェクト、またはnull
 */
export async function reverseGeocodingWithGranularity(lat, lng) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}&language=ja`;
    try {
        // APIにリクエストを送信
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('APIリクエストに失敗しました');
        }

        // レスポンスデータをJSON形式で取得
        const data = await response.json();

        if (!data.features || data.features.length === 0) {
            return null;
        }

        // 粒度ごとに分割
        const addressDetails = {
            fullAddress: data.features[0]?.place_name || null, // 完全な住所
            prefecture: '', // 都道府県
            city: '', // 市区町村
            specific: '', // 場所名
        };

        // コンテキストから粒度ごとに分割
        console.log(data);
        addressDetails.specific = data.features[0]?.text_ja; // 場所名

        data.features[0]?.context.forEach((item) => {
            if (item.id.includes('region')) {
                addressDetails.prefecture = item.text_ja; // 都道府県
            } else if (item.id.includes('place')) {
                addressDetails.city = item.text_ja; // 市区町村
            }
        });

        return addressDetails;
    } catch (error) {
        return addressDetails;
    }
}
